import useFirestoreUser from './useFirestoreUser'
import useIsRole from './useIsRole'
import useIsSuperAdmin from './useIsSuperAdmin'
import useStore from '../store/useStore'

/**
 * Hook to check if the current user can manage research (add, edit, delete)
 * Allowed users:
 * - Users with roles: admin, superadmin, researcher
 * - Users with diagnosis: administrator, medical
 */
export default function useCanManageResearch(): boolean {
  const isImpersonating = useStore(
    (state) => state.identityStatus === 'impersonating',
  )
  const user = useFirestoreUser()
  const isAdmin = useIsRole('admin')
  const isSuperAdmin = useIsSuperAdmin()
  const isResearcher = useIsRole('researcher')

  // Check roles
  const hasManagementRole = isAdmin || isSuperAdmin || isResearcher

  // Check diagnosis
  const hasMedicalDiagnosis =
    user?.profile?.diagnosis === 'administrator' ||
    user?.profile?.diagnosis === 'medical'

  return !isImpersonating && (hasManagementRole || hasMedicalDiagnosis)
}
